<template lang="pug">
div
  .simpleUpload
    uploader.uploader-example(
      ref="uploader",
      :options="options",
      :auto-start="autoStart",
      @file-added="onFileAdded",
      :file-status-text="fileStatusText",
      @file-complete="onFileComplete",
      @file-error="onFileError",
      @dragover="onDragover",
      @dragenter="onDragenter",
      @dragleave="onDragleave"
    )
      uploader-unsupport
      uploader-btn(ref="fileBtn", :attrs="attrs", v-show="false") 选择上传文件
      uploader-btn(ref="folderBtn", v-show="false", :directory="true") 选择上传文件夹
      uploader-list(v-if="hasPanel && panelShow")
        .file-panel(:class="{ collapse: collapse }")
          .file-title
            el-tooltip
              h3 上传列表
              template(#content)
                p.tooltip-text 全部: {{ allFiles.length }}
                p.tooltip-text.text-success 成功: {{ allFiles.filter((file) => file.completed).length }}
                p.tooltip-text.text-error 失败: {{ allFiles.filter((file) => file.error).length }}
            el-select.filter-bar(v-if="!collapse", v-model="files_filter.status", filterable, size="mini")
              el-option(v-for="{ id, cnName } in dicts.filter_status", :key="id", :label="cnName", :value="id")
            .operate
              el-button(:title="collapse ? '展开' : '折叠'", type="text", @click="fileListShow")
                i#uploadFrameBtn(:class="collapse ? 'el-icon-copy-document' : 'el-icon-minus'")
              el-button(type="text", title="关闭", @click="close")
                i.el-icon-close
          el-collapse-transition
            ul.file-list.stylus(v-if="!collapse")
              li(v-for="(file, index) in fileFilterList", :key="file.id")
                uploader-file.new-style(ref="files", :key="listKey", :file="file", :list="true")
                  template(#default="row")
                    .file-row
                      i.uploader-file-icon(:icon="row.fileCategory")
                      .file-label
                        el-tooltip(placement="top-start", :content="file.relativePath")
                          .file-name {{ file.relativePath }}
                        .file-size {{ row.formatedSize }}
                      .file-status
                        span(v-if="file.formatText") {{ file.formatText }}
                        template(v-else-if="row.status !== 'uploading'")
                          el-tooltip(:disabled="!file.errorText", :content="file.errorText", placement="left")
                            span {{ row.status | status }}
                        template(v-else)
                          .progress {{ row.progressStyle.progress }}
                          .speed {{ row.formatedAverageSpeed }}
                      .file-actions.uploader-file-actions
                        span.uploader-file-pause(@click="fileRefActionFn('pause', index)")
                        span.uploader-file-resume(@click="fileRefActionFn('resume', index)")
                        span.uploader-file-retry(@click="fileRefActionFn('retry', index)")
                        span.uploader-file-remove(@click="fileRefActionFn('remove', index)")
              .no-file(v-if="!allFiles.length")
                i.nucfont.inuc-empty-file
                | 暂无待上传文件
  #mask(ref="mask")
    | 请将文件拖放至此处，上传到当前文件夹下
</template>

<script>
// 插件文档链接 https://github.com/simple-uploader/vue-uploader/blob/master/README_zh-CN.md
import { uploadFileFolder, getToken, uploadFileFolderNoPermission } from "@/CommonDP/utils";
import docService from "@/CommonDP/service/doc-service";
import { mapState } from "vuex";
import SparkMD5 from "spark-md5";
import Vue from "vue";
import uploader from "vue-simple-uploader";
import { throttle } from "lodash-es";
import axios from "@/CommonDP/utils/request";
import Axios from "axios";
Vue.use(uploader);
const status_enum = {
  all: "",
  error: "error",
  paused: "paused",
  uploading: "uploading",
  waiting: "waiting",
  success: "success"
};
const CHUNKSIZE = 4 * 1024 * 1024;
function sleep(time = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}
const fileStatusText = {
  success: "上传成功",
  error: "上传失败",
  uploading: "上传中",
  paused: "已暂停",
  waiting: "等待中"
};
export default {
  filters: {
    status(status) {
      let txt = status;
      txt = fileStatusText[status];
      return txt || status;
    },
    speed() {}
  },
  props: {
    // 1是来自项目/文档 2是来自我的文档 3是来自企业文档 4是来自流程 5是来自批注和问题管理  6来自项目-公告 7来自设置-公告(系统) 8审批时审批人文件上传 9 10族库管理 11部门文档 12文档里上传轻量化文件
    typeKey: {
      // 上传类型
      type: String,
      default: "1"
    },
    // 是否需要上传列表,默认需要
    hasPanel: {
      // 上传类型
      type: Boolean,
      default: false
    },
    beforeUpload: {
      type: [Function],
      default: undefined
    },
    // 上传列表
    fileList: {
      type: Array,
      default: () => []
    },
    uploadBtnShow: {
      // 上传按钮权限
      type: Boolean,
      default: true
    },
    isShowUploader: {
      // 上传 文件权限
      type: Boolean,
      default: true
    },
    isShowAddFolder: {
      // 上传 文件夹权限
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      listKey: 0,
      attrs: {
        accept: "image/*"
      },
      options: {
        // 上传地址
        target: () => {
          return this.typeKey === "11" ? uploadFileFolderNoPermission : uploadFileFolder;
        },
        // 处理请求参数
        processParams: (params, file, _uploader, isTest) => {
          const { prjId, folderId, versionId, enterpriseId } = file;
          params.prjId = prjId;
          params.folderId = folderId;
          params.versionId = versionId;
          params.enterpriseId = enterpriseId;
          if (isTest) {
            params.filename = encodeURIComponent(params.filename);
            params.relativePath = encodeURIComponent(params.relativePath);
          }
          return params;
        },
        chunkSize: 4 * 1024 * 1024, // 分块大小
        fileParameterName: "file", // 上传文件时文件的参数名，默认file
        maxChunkRetries: 3, // 最大自动失败重试上传次数
        testChunks: true, // 是否开启服务器分片校验
        // autoStart: true, //默认 true, 是否选择文件后自动开始上传。
        speedSmoothingFactor: 0.02, // 平均速度
        progressCallbacksInterval: 500, // 平均速度回調時間
        simultaneousUploads: 4, // 并发上传数
        // 用于格式化你想要剩余时间，一般可以用来做多语言:
        // timeRemaining{Number}, 剩余时间，秒为单位;
        // parsedTimeRemaining{String}, 默认展示的剩余时间内容，你也可以这样做替换使用
        parseTimeRemaining: (timeRemaining, parsedTimeRemaining) => {
          return parsedTimeRemaining
            .replace(/\byears?\b/, "年")
            .replace(/\bdays?\b/, "天")
            .replace(/\bhours?\b/, "小时")
            .replace(/\bminutes?\b/, "分钟")
            .replace(/\bseconds?\b/, "秒");
        },
        preprocess: (chunk) => {
          let wait = Promise.resolve();
          const file = chunk.file;
          if (!chunk.tested) {
            file.formatText = "准备中";
            wait = this.computeMD5(file).then(() => this.waitMd5Lock(file));
            // .then(() => this.customTest(chunk));
          }
          wait
            .then(
              () => {
                chunk.preprocessFinished();
              },
              (e) => {
                const msg = e?.data?.message || e?.message || e || "处理文件失败";
                const status = chunk.constructor.STATUS.ERROR;
                chunk._event(status, msg);
                chunk.abort();
              }
            )
            .finally(() => {
              file.formatText = "";
            });
        },
        // 服务器分片校验函数，秒传及断点续传基础
        // this:当前上传文件实例
        checkChunkUploadedByResponse: function (chunk, result) {
          const res = JSON.parse(result);
          if (res.result === "0") {
            const { uploaded = [], skipUpload, folderId, fileInfo } = res.data || {};
            const skip = skipUpload || uploaded.indexOf(chunk.offset + 1) !== -1;
            this.skipUpload = skipUpload;
            this.folderId = folderId;
            this.fileInfo = fileInfo;
            chunk.skipUpload = skip;
            return skip;
          } else {
            const msg = res.message;
            chunk.abort();
            return new Error(msg);
          }
        },
        categoryMap: {
          // 文件类型 map
          image: ["gif", "jpg", "jpeg", "png", "bmp", "webp"],
          video: ["mp4", "m3u8", "rmvb", "avi", "swf", "3gp", "mkv", "flv"],
          audio: ["mp3", "wav", "wma", "ogg", "aac", "flac"],
          doc: ["doc"],
          xls: ["xls"],
          ppt: ["ppt"],
          pdf: ["pdf"],
          txt: ["txt"],
          rvt: ["rvt"],
          dwg: ["dwg"],
          docx: ["docx"],
          xlsx: ["xlsx"],
          pptx: ["pptx"],
          zip: ["zip", "rar"],
          exe: ["exe"],
          rfa: ["rfa"],
          fbx: ["fbx"],
          obj: ["obj"],
          glb: ["glb"]
        },
        headers: {
          Authorization: "Bearer " + getToken()
        },
        // 处理请求结果
        // 每次上传请求成功和失败后都会调用
        processResponse: async (response, cb, file) => {
          const res = JSON.parse(response) || {};
          if (res.result === "0") {
            if (res.data?.needMerge) {
              const { identifier, filename, relativePath, prjId, folderId, versionID: versionId } = res.data;
              const params = { identifier, filename, relativePath, prjId, folderId, versionId };
              const margeReq = this.typeKey === "11" ? docService.fileMergeNoPermissionAsync(params) : docService.fileMergeAsync(params);
              margeReq.catch((e) => {
                const msg = e?.data?.message || "合并失败";
                cb(new Error(msg), msg);
                file.abort();
              });
              const { data = {}, message } = await margeReq;
              const { asyncKey, fileId } = data;
              if (asyncKey) {
                this.setMergeTimer({ prjId, asyncKey }).then(
                  (fileInfo) => {
                    const obj = {
                      fileName: fileInfo.fileName,
                      fileType: fileInfo.fileType,
                      fileId: fileInfo.fileId,
                      versionIds: fileInfo.fileVersion,
                      uploadType: this.typeKey,
                      status: fileInfo.status,
                      fileSize: fileInfo.fileSize,
                      checkInUser: fileInfo.checkInUser || fileInfo.operUserName,
                      checkInDate: fileInfo.checkInDate || fileInfo.createTime
                    };
                    this.fileAdded(obj, file.folderId);
                    cb(null, fileInfo);
                  },
                  (e) => {
                    const msg = e?.data?.message || "合并文件接口处理失败！";
                    cb(new Error(msg), msg);
                    file.abort();
                  }
                );
              } else if (!asyncKey && fileId) {
                const obj = {
                  fileName: data.fileName,
                  fileType: data.fileType,
                  fileId: data.fileId,
                  versionIds: data.fileVersion,
                  uploadType: this.typeKey,
                  status: data.status,
                  fileSize: data.fileSize,
                  checkInUser: data.checkInUser || data.operUserName,
                  checkInDate: data.checkInDate || data.createTime
                };
                this.fileAdded(obj, file.folderId);
                cb(null, data);
              } else {
                const msg = message || "合并文件接口处理失败！";
                cb(new Error(msg), msg);
                file.abort();
              }
            } else {
              cb(null, response);
            }
          } else {
            if (!file.relativePath.includes("/")) {
              const msg = res.message || "上传失败";
              cb(new Error(msg), msg);
              file.abort();
            } else {
              const msg = res.message ? `${file.name},${res.message}` : `${file.name}上传失败`;
              this.$message.warning(msg);
              cb(new Error(msg), msg);
              file.abort();
            }
          }
        }
      },
      files_filter: {
        status: ""
      },
      dicts: {
        filter_status: [
          { id: status_enum.all, cnName: "全部" },
          { id: status_enum.error, cnName: "上传失败" },
          { id: status_enum.uploading, cnName: "上传中" },
          { id: status_enum.success, cnName: "上传成功" }
        ]
      },
      autoStart: false, // 默认 true, 是否选择文件后自动开始上传。
      panelShow: false, // 选择文件后，展示上传panel
      collapse: false,
      maxSize: 1024 * 1024 * 1024 * 5, // 上传最大内存(目前设置为5G)
      fileStatusText,
      uploaderParams: {
        prjId: "",
        folderId: "",
        versionId: "",
        enterpriseId: ""
      },
      skipUpload: false,
      folderId: "",
      fileInfo: {},
      isBind: false,
      drag: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      currentNode: (state) => state.XtDesign?.currentTreeNode,
      currentNodeMyDocOrDeptDoc: (state) => state.perFile?.currentTreeNodeDan,
      currentNodeEnterprise: (state) => state.perFile?.currentTreeNodeFen,
      prjInfo: (state) => state.projectMg.prjObj // 项目
    }),
    uploader() {
      return this.$refs.uploader.uploader;
    },
    allFiles() {
      const { uploader, listKey } = this;
      listKey;
      if (!uploader) return [];
      const fileList = uploader.files;
      return fileList;
    },
    fileFilterList() {
      const {
        allFiles: fileList,
        files_filter: { status }
      } = this;
      if (status === status_enum.all) return fileList;
      const files = fileList.filter((file) => {
        switch (status) {
          case status_enum.error:
            return file.error;
          case status_enum.success:
            return file.completed;
          case status_enum.uploading:
            return !file.error && !file.completed;
          default:
            return false;
        }
      });
      return files;
    }
  },
  watch: {
    currentNode(newValue) {
      if (newValue) {
        let { data } = newValue;
        data = data || {};
        data.prjId = this.prjInfo.prjId;
        this.isDrag(data);
      }
    },
    currentNodeMyDocOrDeptDoc(newValue) {
      if (newValue) {
        let data = newValue;
        data = data || {};
        data.prjId = this.typeKey === "2" ? "MyDoc" : "EnterpriseDeptDoc";
        this.isDrag(data);
      }
    },
    currentNodeEnterprise(newValue) {
      if (newValue) {
        let data = newValue;
        data = data || {};
        data.prjId = "EnterpriseDoc";
        this.isDrag(data);
      }
    }
  },
  methods: {
    async setMergeTimer({ asyncKey, prjId }) {
      let next = true;
      this.$on("hook:beforeDestroy", () => {
        next = false;
      });
      do {
        await sleep(5000);
        const { data: fileInfo } = await docService.queryMergeResult(asyncKey, prjId);
        if (!fileInfo) throw new Error({ data: { message: "获取合并数据失败" }});
        if (!fileInfo.asyncKey && fileInfo.fileId) return fileInfo;
      } while (next);
    },
    // 覆盖uploader默认的上传测试
    customTest(chunk) {
      const $ = chunk;
      const uploader = $.uploader;
      const file = $.file;
      const STATUS = $.constructor.STATUS;
      let abort;
      // 添加取消请求
      const cancelToken = new Axios.CancelToken((c) => {
        abort = c;
      });
      // 完善测试请求参数
      const params = uploader.opts.processParams(
        {
          ...$.getParams(),
          ...this.uploader.opts.query
        },
        file,
        $,
        true
      );
      const testReq = axios({
        url: "/doc/chunk",
        params,
        cancelToken
      }).then(
        (data) => {
          const res = JSON.stringify(data);
          Object.assign($.xhr, {
            status: 200,
            statusText: "",
            responseText: res,
            response: res,
            readyState: XMLHttpRequest.DONE
          });
          $.preprocessState = 2;
          $.readState = 2;
          const status = $.status(true);
          // if (data.data.skipUpload) {
          //   $.readState = 1;
          // }
          if (status === STATUS.SUCCESS) {
            $._event(status, $.message());
            $.readState = 0;
            $.tested = true;
            // $.xhr = null;
          } else if (!$.file.paused) {
            // Error might be caused by file pause method
            // Chunks does not exist on the server side
            $.tested = true;
            // $.send();
          }
        },
        (err) => {
          const msg = err?.data?.message || "文件校验失败";
          Object.assign($.xhr, {
            status: 400,
            statusText: "",
            readyState: XMLHttpRequest.DONE,
            responseText: msg,
            response: msg
          });
          const status = $.status(true);
          $._event(status, $.message());
          $.uploader.uploadNextChunk();
        }
      );
      // 补充请求xhr,防止后续判断失败
      $.xhr = {
        timeout: 0,
        readyState: XMLHttpRequest.OPENED,
        status: 0,
        abort
      };
      return testReq;
    },
    fileRefActionFn(actionName, index) {
      return this.$refs.files?.[index]?.[actionName]?.();
    },
    /**
     * @description: 上传文件启动方法
     * @param {params.prjId} 项目id(不建议为空)
     * @param {params.folderId} 文件id，可为空：没有文件id的根据项目id查找本地上传隐藏文件夹
     * @param {params.versionId} 文件版本
     * @param {type} 上传模式："folder"-文件夹
     *
     */
    async openUploader(params, type) {
      const { prjId = "", folderId = "", versionId = "" } = params;
      this.uploaderParams.folderId = folderId || (await this.queryhiddenFolder(prjId));
      this.uploaderParams.prjId = prjId || "EnterpriseDoc";
      this.uploaderParams.versionId = versionId;
      this.uploaderParams.enterpriseId = this.enterpriseId;
      if (type === "folder") {
        this.$refs.folderBtn.$el.click();
      } else {
        if (this.typeKey === "9") {
          this.$refs.fileBtn.$el.children[0].accept = ".rfa";
          this.$refs.fileBtn.$el.children[0].multiple = false;
        } else if (this.typeKey === "10") {
          this.$refs.fileBtn.$el.children[0].accept = ".rfa";
          this.$refs.fileBtn.$el.children[0].multiple = true;
        } else if (this.typeKey === "12") {
          this.$refs.fileBtn.$el.children[0].accept = ".bimex";
          this.$refs.fileBtn.$el.children[0].multiple = false;
        } else {
          this.$refs.fileBtn.$el.children[0].accept = "*";
          this.$refs.fileBtn.$el.children[0].multiple = true;
        }
        this.$refs.fileBtn.$el.click();
      }
    },
    // 回调上传成功的数据
    async fileAdded(data, folderId) {
      if (this.fileList.length > 0 && this.fileList.some((e) => e.fileName === data.fileName && e.fileId === data.fileId && e.versionIds === data.versionIds)) {
        this.$message.warning(`文件${file.name}上传失败，已存在同名文件`);
        return;
      }
      // 回调上传数据
      this.$emit("fileAdded", data);
      // 之前代码做的通信方式，后期不考虑
      this.uploadSucceedCB(folderId, data);
    },
    uploadSucceedCB: throttle(function (folderId, data) {
      switch (this.typeKey) {
        case "1":
          this.$store.dispatch("XtDesignUploadSucceedCB", folderId);
          break;
        case "2": // 个人 ""MyDoc""
          this.$store.dispatch("perFileUploadSucceedCB", folderId);
          break;
        case "3": // 企业""EnterpriseDoc""
          this.$store.dispatch("perFileUploadSucceedCB", folderId);
          break;
        case "11": // 部门文档
          this.$store.dispatch("perFileUploadSucceedCB", folderId);
          break;
        case "4": // 流程
          this.$store.dispatch("LocalUploadSucceedFloder", data);
          break;
        default:
          break;
      }
    }, 5000),
    // 上传操作：选择文件后第一步触发，单文件上传
    async onFileAdded(file) {
      Vue.observable(file);
      this.$set(file, "formatText", "");
      this.$set(file, "errorText", "");
      if (this.drag && !file.relativePath.includes("/") && !this.isShowUploader && this.uploadBtnShow) {
        this.$message.warning("当前文件夹下没有上传文件的权限");
        file.ignored = true;
      }
      if (this.drag && file.relativePath.includes("/") && !this.isShowAddFolder && this.uploadBtnShow) {
        this.$message.warning("当前文件夹下没有上传文件夹的权限");
        file.ignored = true;
      }
      const type = file.name.replace(/.+\./, "");
      const fileTypeList = ["rfa"];
      if (this.typeKey === "9" || this.typeKey === "10") {
        if (!fileTypeList.some((e) => e === type)) {
          this.$message.warning("上传文件只支持rfa格式");
          file.ignored = true;
        }
      }
      if (file.size === 0) {
        this.$message.error("不能上传空文件！名称：" + file.name + "；");
        file.ignored = true;
      }
      if (file.size > this.maxSize) {
        this.$message.error("文件大小超出最大上传5GB");
        file.ignored = true;
      }
      try {
        if (file.ignored) return;
        const unput = await this.beforeUpload?.(file);
        if (unput === false) throw new Error("不允许上传该文件");
        this.panelShow = true;
        this.$emit("add", file);
        this._setParams(file);
        file.resume();
      } catch (error) {
        file.ignored = true;
      }
    },
    async _setParams(file) {
      file.prjId = this.uploaderParams.prjId;
      file.folderId = this.uploaderParams.folderId;
      file.versionId = this.uploaderParams.versionId;
      file.enterpriseId = this.uploaderParams.enterpriseId;
    },
    /**
     * 计算md5值，以实现断点续传及秒传
     * @param file
     * @returns Promise
     */
    computeMD5(file) {
      const fileReader = new FileReader();
      const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      const chunks = Math.ceil(file.size / chunkSize); // 总块数
      const spark = new SparkMD5.ArrayBuffer();
      loadNext();
      return new Promise((resolve, reject) => {
        fileReader.onload = (e) => {
          spark.append(e.target.result);
          if (currentChunk < chunks) {
            currentChunk++;
            loadNext();
          } else {
            const md5 = spark.end();
            file.uniqueIdentifier = md5;
            resolve(md5);
          }
        };
        fileReader.onerror = function () {
          this.error(`文件${file.name}读取出错，请检查该文件`);
          file.cancel();
          reject();
        };
      });
      function loadNext() {
        const start = currentChunk * chunkSize;
        const end = start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },
    // 添加md5锁,如果不允许次md5上传
    async waitMd5Lock(file) {
      const md5 = file.uniqueIdentifier;
      let lock = true;
      do {
        if (file.aborted || file.completed || file.error || file.uploader.aborted) throw new Error("上传已取消");
        // 检测md5锁,md5锁会继续循环
        const { data } = await docService.lockForUpload(md5, encodeURIComponent(file.name));
        lock = data === 1;
        // 成功,将跳出循环
        await sleep(3000);
      } while (lock);
    },
    // 折叠
    fileListShow() {
      this.collapse = !this.collapse;
    },
    // 关闭
    async close() {
      if (!this.uploader.isComplete()) {
        await this.$confirm("上传列表关闭,未上传成功的文件将取消上传,确定关闭?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
      }
      this.uploader.cancel();
      this.panelShow = false;
    },
    onFileComplete(rootFile) {
      if (rootFile.skipUpload) {
        const data = rootFile.fileInfo;
        const obj = {
          fileName: data.fileName,
          fileType: data.fileType,
          fileId: data.fileId,
          versionIds: data.version,
          uploadType: this.typeKey,
          status: data.status,
          fileSize: data.fileSize,
          checkInUser: data.checkInUser || data.operUserName,
          checkInDate: data.checkInDate || data.createTime
        };
        this.fileAdded(obj, rootFile.folderId);
      }
      if (rootFile.files.length > 0) {
        for (var i = 0; i < rootFile.files.length; i++) {
          if (rootFile.files[i].skipUpload) {
            this.uploadSucceedCB(this.uploaderParams.folderId);
          }
        }
      }
    },
    // 没有文件id的根据项目id查找本地上传隐藏文件夹
    async queryhiddenFolder(prjId) {
      if (prjId) {
        const { data } = await docService.queryhiddenFolder(prjId);
        return data || "";
      } else {
        const { data } = await docService.queryEnterpriseIdhiddenFolder(this.enterpriseId);
        return data || "";
      }
    },
    // 文件上传出错
    onFileError(rootFile, file, msg) {
      this.$emit("file-error", file, msg);
      file.errorText = msg;
      this.$message.warning(`${file.relativePath}上传失败,${msg}`);
    },
    onDragover(event) {
      event.preventDefault();
    },
    onDragenter(event) {
      event.preventDefault();
    },
    onDragleave(event) {
      event.preventDefault();
      document.querySelector("#mask").style.visibility = "hidden";
    },
    async isDrag(folderObj) {
      const { prjId, folderId } = folderObj;
      this.uploaderParams.prjId = prjId;
      this.uploaderParams.folderId = folderId || (await this.queryhiddenFolder(prjId));
      if (this.isBind) return;
      else {
        // 因为现在是最外面上传 所有的页面的都能拖动 加一下判断
        var rsur = window.location.href.split("/#/")[1];
        const _isDepDoc = rsur.includes("depDoc-");
        if (rsur === "project-XtDesign" || rsur === "mydoc" || rsur === "sharinformation" || rsur === "Publicinformation" || _isDepDoc) {
          this._initDragover();
        }
      }
    },
    _initDragover() {
      var _this = this;
      _this.drag = true;
      const mask = document.getElementById("mask");
      _this.uploader.assignDrop(mask);
      var lastTarget = null;
      window.addEventListener("dragenter", function (e) {
        lastTarget = e.target;
        mask.style.visibility = "visible";
      });
      window.addEventListener("dragleave", function (e) {
        if (e.target === lastTarget || e.target === document) {
          mask.style.visibility = "hidden";
        }
      });
      mask.addEventListener("drop", function (e) {
        mask.style.visibility = "hidden";
      });
      _this.isBind = true;
    }
  },
  mounted() {
    const timer = setInterval(() => {
      if (!this.collapse) this.listKey++;
    }, 1000);
    this.$on("beforeDestroy", () => {
      clearInterval(timer);
    });
  }
};
</script>
<style scoped lang="scss" src="./upload.scss">
